<template>
    <div class="modal-card drawer_opener" id="main_div_classificator_drawer">
        <header class="modal-card-head grey_header">
            <div class="header_container px-5 is-flex is-align-items-stretch">
                <div class="is-flex is-flex-direction-column" v-if="!!localCounterpart.rut">
                    <p class="classify_title mb-1 is-align-self-flex-start">
                        {{ localCounterpart.alias }}
                    </p>
                    <div class="mt-auto is-flex is-flex-wrap-wrap is-gap is-align-items-center">
                        <!-- En el Libro Mayor (read-only) el RUT es siempre el
                             placeholder: no se muestra. -->
                        <span v-if="!readOnly && localCounterpart.counterpart_type != 'Recibo'"
                            class="has-text-left mt-2 classify_subtitle nobreak">
                            {{ localCounterpart.rut }}
                        </span>
                        <CounterpartTypePill
                            class="nobreak mt-2"
                            :type="localCounterpart.counterpart_type"
                            size="xl" />
                        <ClassificationPill
                            class="nobreak mt-2"
                            :value="localCounterpart.classify_by_counterpart"
                            label-style="verbose"
                            size="xl" />
                        <span v-if="readOnly" class="readonly_badge nobreak mt-2">
                            Solo lectura · Libro Mayor
                        </span>
                    </div>
                </div>
                <div class="is-flex is-flex-direction-column">
                    <div class="is-align-self-flex-end">
                        <button class="close_button" aria-label="Cerrar Modal" @click="closeModal()">
                            <Ecs class="ecs" />
                        </button>
                    </div>
                    <div class="fecha_selector mt-auto">
                        <SelectComponent class="select_component has-text-left" v-model="localRangePeriod"
                            currentIcon="calendar" :options="periodDataSelect" :weirdOptions="null" />
                    </div>
                </div>
            </div>
        </header>
        <section class="modal_back_caa" ref="scrollContainer">
            <div v-if="!readOnly && localCounterpart.obligation_name != 'finiquitos-clf'"
                class="classificator_tree_container is-flex is-flex-direction-column">
                <div class="is-flex is-flex-direction-row is-flex-grow-1">
                    <div class="is-flex-grow-2">
                        <div class="header_title">
                            Clasificar por contraparte
                        </div>
                        <div class="header_subtitle">
                            Clasifica una vez y aplica automáticamente a futuras facturas
                        </div>
                    </div>
                </div>
                <div class="class_tree is-flex-grow-1">
                    <TreeClassificator :classifiedAccounts="classifiedAccounts" :accounts="accountsOrdered"
                        :types="categories" :classifiedAttributes="classifiedAttributes" :allAttributes="allAttributes"
                        :documentType="localCounterpart.pay_or_charge" :contraparteId="localCounterpart.ci_id"
                        :money="localCounterpart.total_3_months" :key="prorateEditKey"
                        :obligationName="localCounterpart.obligation_name"
                        @reload-docs="() => loadProratesByCounterpart(true)" />
                </div>
            </div>
            <div v-if="allDocumentsByCounterpart.length > 0">
                <ClassifyDocuments :classifiedAccounts="classifiedAccounts" :accounts="accountsOrdered"
                    :types="categories" :classifiedAttributes="classifiedAttributes" :allAttributes="allAttributes"
                    :counterpart="localCounterpart" :autoOpenDocId="autoOpenDocId" :readOnly="readOnly"
                    @reload-docs="() => loadAllDocsByCounterpart(true)">
                </ClassifyDocuments>
            </div>
        </section>
    </div>
</template>


<script>

import ClassifyDocuments from "@/components/classification/ClassifyDocuments.vue";
import SelectComponent from "@/components/classification/SelectComponent";
import TreeClassificator from "@/components/classification/TreeClassificator.vue";
import Ecs from "@/components/svg/Ecs.vue";
import CounterpartTypePill from "@/components/generics/CounterpartTypePill.vue";
import ClassificationPill from "@/components/generics/ClassificationPill.vue";
import { mapActions, mapState } from "vuex";

export default {
    name: "ClassifyAccountAttributes",
    components: {
        Ecs,
        ClassifyDocuments,
        TreeClassificator,
        SelectComponent,
        CounterpartTypePill,
        ClassificationPill,
    },
    data() {
        return {
            loading: null,
            accountsOrdered: [],
            total: 0,
            processing: false,
            prorateEditKey: "",
            classifiedAccounts: [],
            allAttributes: [],
            classifiedAttributes: [],
            modalDefault: {
                parent: this,
                width: "99%",
                hasModalCard: true,
                canCancel: ["escape", "outside"],
                customClass: "center-always-modal",
            },
            localCounterpart: {},
            localRangePeriod: '',
            localCategories: [],
        };
    },
    methods: {
        ...mapActions("classification", ["updateCounterpart", "setSelectedCounterpart",
            "setEmptyDocuments", 'getDocuments', 'setExtraInfoDocumentsByCounterpart',
            "fetchCounterpart", "fetchProratesByCounterpart"]),
        closeModal() {
            const modal = document.querySelector('#main_div_classificator_drawer.modal-card.drawer_opener');
            if (modal) {
                modal.classList.remove('drawer_animation');
                modal.classList.remove('drawer_closed');
                setTimeout(() => {
                    this.$emit('close');
                }, 150);
            } else {
                this.$emit('close');
            }
        },
        openModalAnimation() {
            this.$nextTick(() => {
                const drawerElement = document.querySelector(
                    '#main_div_classificator_drawer.modal-card.drawer_opener'
                );

                if (drawerElement) {
                    drawerElement.classList.add('drawer_animation');
                } else {
                    console.warn('Element with id "main_div_classificator_drawer" not found.');
                }
            });
        },
        initLoadClassificationData(data) {
            this.classifiedAccounts = []
            const account_plan_ordered = data['account_plan_ordered'];
            const prorate_x_account = data['prorate_x_account'];
            this.accountsOrdered = [...account_plan_ordered];
            const prorates_x_attribute = data['prorates_x_attribute'];
            const all_attributes = data['all_attributes'];

            this.allAttributes = [...all_attributes]
            this.classifiedAttributes = [...prorates_x_attribute];
            for (const pxa of prorate_x_account) {
                this.classifiedAccounts.push({ id: Number(pxa.id), percentage: pxa.percentage, account: Number(pxa.classified_account) });
            }
            this.prorateEditKey = Date.now();
        },
        loadAllDocsByCounterpart(force = false) {
            const optionSelected = this.periodDataSelect.find(
                (o) => o.value == this.localRangePeriod
            );
            if (force && optionSelected.from) {
                let request = {
                    type: 'all',
                    ci_id: this.localCounterpart.ci_id,
                    pay_or_charge: this.localCounterpart.pay_or_charge,
                    from: optionSelected.from,
                    to: optionSelected.to,
                    obligation_name: this.localCounterpart.obligation_name,
                    // Libro Mayor: pide sólo los documentos del mayor (is_ledger).
                    ledger_only: this.ledgerOnly,
                };
                this.getDocuments(request).then(() => {
                    this.setExtraInfoDocumentsByCounterpart({
                        alias: this.localCounterpart.alias,
                        rut: this.localCounterpart.rut,
                        classifiedAccounts: this.classifiedAccounts,
                        classifiedAttributes: this.classifiedAttributes,
                        attributes: this.allAttributes
                    })
                })
            }
        },
        loadProratesByCounterpart(force = false) {
            this.fetchProratesByCounterpart({
                ciId: this.counterpart.ci_id,
                documentId: this.documentIdSelected,
                payOrCharge: this.counterpart.pay_or_charge,
                obligation: this.counterpart.obligation_name,
            })
                .then((data) => {
                    this.initLoadClassificationData(data)
                    if (force) {
                        this.reloadCounterpart()
                    }
                }).catch(error => {
                    console.error('Error in one of the API calls:', error);
                });
        },
        reloadCounterpart() {
            const optionSelected = this.periodDataSelect.find(
                (o) => o.value == this.localRangePeriod
            );
            this.fetchCounterpart({
                ciId: this.counterpart.ci_id,
                payOrCharge: this.counterpart.pay_or_charge,
                from: optionSelected.from,
                to: optionSelected.to,
                obligation: this.counterpart.obligation_name,
            }).then((data) => {
                const updatedCounterpart = data["page_data"][0];
                if (updatedCounterpart) {
                    const actual_order = this.localCounterpart.actual_order
                    updatedCounterpart["actual_order"] = actual_order;
                    this.localCounterpart = { ...this.localCounterpart, ...updatedCounterpart }
                    this.setSelectedCounterpart(this.localCounterpart)
                    this.loadAllDocsByCounterpart(true)
                }
            });
        },
    },
    computed: {
        ...mapState("classification", ["periodDataSelect", "categories", "allDocumentsByCounterpart"]),
    },
    mounted() {
        this.localRangePeriod = this.rangeFromMainScreen
        this.openModalAnimation()

        this.localCounterpart = JSON.parse(JSON.stringify(this.counterpart))
        this.loadProratesByCounterpart(true)
    },
    beforeDestroy() {
        // Enviar dato al padre justo antes de que el modal desaparezca
        this.updateCounterpart({
            ci_id: this.counterpart.ci_id,
            pay_or_charge: this.counterpart.pay_or_charge,
            obligation_name: this.counterpart.obligation_name
        })
        this.setEmptyDocuments({ type: 'all' })
        this.$emit('reload-counterpart')
    },
    watch: {
        rangeFromMainScreen(newRange) {
            this.localRangePeriod = newRange
        },
        localRangePeriod() {
            this.loadAllDocsByCounterpart(true)
        }
    },
    props: {
        documentIdSelected: { type: Number, default: null },
        rangeFromMainScreen: { type: String, default: "" },
        counterpart: { type: Object, default: () => ({}) },
        // Deep-link desde reportes: td_id cuyo árbol de prorrateo debe abrirse
        // automáticamente en la tabla de documentos. No confundir con
        // documentIdSelected (alimenta el árbol POR CONTRAPARTE).
        autoOpenDocId: { type: Number, default: null },
        // Modo solo lectura (Libro Mayor / ERP): oculta el árbol de prorrateo y
        // toda edición; la tabla de documentos se muestra en read-only.
        readOnly: { type: Boolean, default: false },
        // Pide al backend sólo los documentos del mayor (is_ledger) al cargar.
        ledgerOnly: { type: Boolean, default: false },
    }
};
</script>

<style scoped lang="scss">
* {
    font-family: Inter;
}

.classificator_tree_container {
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid #d0d5dd;
    margin-bottom: 16px;
    padding: 20px;
}

.header_title {
    width: 100%;
    position: relative;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    font-family: Inter;
    color: #101828;
    text-align: left;
    display: inline-block;
}

.header_subtitle {
    width: 100%;
    position: relative;
    font-size: 14px;
    line-height: 20px;
    color: #475467;
    text-align: left;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.fecha_selector {
    width: 230px;
    max-width: 230px;
    padding-top: 12px;
}

.select_component {
    width: 230px;
}

// Las pills de tipo y de clasificación usan <CounterpartTypePill> y
// <ClassificationPill>. Este modal ya no define estilos de pill.

.close_button {
    margin: 0 !important;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid #d0d5dd;
    box-sizing: border-box;
    width: 36px;
    height: 36px;
    overflow: hidden;
    padding-top: 5px;
}


.grey_header {
    width: 100%;
    background-color: #eaecf0;
    padding: 24px 0px 32px 0px;
    box-sizing: border-box;
    gap: 24px;
    text-align: left;
    font-size: 30px;
    color: #101828;
}

.header_container {
    justify-content: space-between;
    width: 100%;
    min-width: 100%;
}

.modal_back_caa {
    background-color: #fcfcfd;
    padding: 32px;
    overflow-y: scroll;
}

.classify_title {
    font-size: 30px;
    line-height: 38px;
    font-weight: 600;
    color: #101828;
}

.classify_subtitle {
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    color: #475467;
    width: fit-content;
}

.drawer_opener {
    position: absolute !important;
    top: 0 !important;
    height: 100% !important;
    max-height: 100% !important;
    background: white;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    transition: right 0.35s ease-in-out;
    z-index: 1050;
    width: 75%;
}

.drawer_animation {
    right: 0px !important;
}

.drawer_closed {
    right: -3000px !important;
}

.ecs {
    width: 100%;
    position: relative;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
}

.nobreak {
    white-space: nowrap;
}

.readonly_badge {
    align-self: center;
    font-size: 13px;
    font-weight: 600;
    color: #0d5154;
    background: rgba(13, 81, 84, 0.08);
    border: 1px solid rgba(13, 81, 84, 0.18);
    border-radius: 999px;
    padding: 4px 12px;
}
</style>
